// ============================================
// SERVICE D'INTÉGRATION BKAPAY — Liens directs
// Lien BKaPay  : https://bkapay.com/pay/b7213d6c
// Lien MoneyFusion : https://my.moneyfusion.net/69943d3a720a7f15e8b1fff6
// ============================================

export const BKAPAY_DIRECT_URL      = 'https://bkapay.com/pay/b7213d6c';
export const MONEYFUSION_DIRECT_URL = 'https://my.moneyfusion.net/69943d3a720a7f15e8b1fff6';

export interface BKaPayRedirectRequest {
  amount: number;
  currency: string;
  reference: string;
}

export interface BKaPayRedirectResponse {
  url: string;
  transactionId: string;
}

export interface BKaPayStatusResponse {
  success: boolean;
  status?: 'PAID' | 'PENDING' | 'FAILED' | 'EXPIRED';
  transactionId?: string;
  amount?: number;
  currency?: string;
  error?: string;
}

/**
 * Retourne le lien direct BKaPay pour redirection immédiate
 */
export async function initiateBKaPayRedirect(
  request: BKaPayRedirectRequest
): Promise<BKaPayRedirectResponse> {
  return {
    url: BKAPAY_DIRECT_URL,
    transactionId: request.reference,
  };
}

/**
 * Retourne le lien direct BKaPay (alias simple)
 */
export function buildBKaPayRedirectUrl(): string {
  return BKAPAY_DIRECT_URL;
}

/**
 * Vérifie si BKaPay est configuré
 */
export function isBKaPayConfigured(): boolean {
  return true;
}

/**
 * Stub de vérification de statut (non utilisé avec les liens directs)
 */
export async function checkBKaPayStatus(
  _transactionId: string
): Promise<BKaPayStatusResponse> {
  return { success: false, status: 'PENDING', error: 'Vérification manuelle requise' };
}